import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/dept/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/userservice/api/dept/detail',
    method: 'post',
    data: data
  });
}
export function fetchDelete(deptIds) {
  var data = {
    deptIds: deptIds
  };
  return request({
    url: '/userservice/api/dept/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/dept/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/dept/update',
    method: 'post',
    data: data
  });
}
export function fetchDeptTree(data) {
  return request({
    url: '/userservice/api/dept/tree',
    method: 'post',
    data: data
  });
}